import React, { useState } from "react";
import "../styles/Signup.css";
import { Link, useNavigate } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

/* ─── Icons ─── */
const ConvertIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const InfinityIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.644-8 12.74-8z" />
  </svg>
);
const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const ZapIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);
const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
  </svg>
);
const EyeOffIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" /><path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
  </svg>
);
const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
  </svg>
);
const YahooIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#6001D2">
    <path d="M14.53 3l-3.08 7.18L8.37 3H3l5.97 11.84v6.16h4.06v-6.16L19 3h-4.47zM20.5 3h-3.65l1.73 4.03L20.5 3z" />
  </svg>
);
const FacebookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);
const OutlookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#0078D4">
    <path d="M24 7.387v10.478c0 .23-.08.424-.238.576a.806.806 0 0 1-.588.234h-8.42v-6.56l1.678 1.233a.38.38 0 0 0 .46 0L24 8.238V7.387zm-9.246 5.478V5.058l-.24-.004H8.42A.818.818 0 0 0 7.83 5.3a.776.776 0 0 0-.234.572v12.26c0 .222.08.414.236.572a.818.818 0 0 0 .59.242h14.752a.806.806 0 0 0 .588-.234.782.782 0 0 0 .238-.576v-.56L14.754 12.865zM14.166 0v4.946H7.596V5.28L0 1.588V18.4l7.596 4.326V5.946h6.57L24 12.06V4.946l-2.508-1.652L14.166 0zM7.26 15.1a3.465 3.465 0 0 1-1.058-2.555c0-.995.352-1.848 1.058-2.556a3.553 3.553 0 0 1 2.6-1.064 3.55 3.55 0 0 1 2.598 1.064 3.465 3.465 0 0 1 1.06 2.556 3.465 3.465 0 0 1-1.06 2.555 3.55 3.55 0 0 1-2.598 1.064 3.553 3.553 0 0 1-2.6-1.064z" />
  </svg>
);
const AppleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#000000">
    <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.52-3.23 0-1.44.64-2.2.52-3.06-.4C3.79 16.17 4.36 9.02 8.72 8.76c1.29.07 2.19.72 2.95.78.98-.2 1.92-.76 2.96-.69 1.26.1 2.2.6 2.83 1.49-2.59 1.55-1.97 4.97.42 5.93-.49 1.3-.74 1.86-1.83 3.01zM12.05 8.68c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);
const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const FEATURES = [
  { icon: <InfinityIcon />, title: "Unlimited Conversions", desc: "Convert as many files as you need with no daily limits" },
  { icon: <ShieldIcon />, title: "Enterprise Security", desc: "256-bit AES encryption and automatic file deletion" },
  { icon: <ZapIcon />, title: "Lightning Fast", desc: "GPU-accelerated processing for instant results" },
];

export default function ConvertProSignUp() {
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();

  const { executeRecaptcha } =
    useGoogleReCaptcha();

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  const [success, setSuccess] =
    useState("");

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSignup = async (e) => {

    e.preventDefault();

    setError("");
    setSuccess("");

    if (
      !form.name ||
      !form.email ||
      !form.password ||
      !form.confirm
    ) {
      setError(
        "Please fill all required fields."
      );
      return;
    }

    if (form.password.length < 8) {
      setError(
        "Password must be at least 8 characters."
      );
      return;
    }



    if (
      form.password !== form.confirm
    ) {
      setError(
        "Passwords do not match."
      );
      return;
    }

    try {

        if (!executeRecaptcha) {
                setError(
                  "reCAPTCHA is still loading. Please try again."
                );
                return;
              }

      setLoading(true);



      const recaptchaToken =
        await executeRecaptcha("signup");

      const response =
        await fetch(
          `${API_URL}/signup`,
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({
              full_name: form.name,
              email: form.email,
              password: form.password,
              role: "User",
              recaptcha_token:
                recaptchaToken
            })
          }
        );

      const data =
        await response.json();

      if (!response.ok) {

        throw new Error(
          data.detail ||
          "Signup failed"
        );

      }

      setSuccess(
        "Account created successfully. Please check your email and verify your account before logging in."
      );

      setTimeout(() => {
        navigate("/login");
      }, 3000);

      setForm({
        name: "",
        email: "",
        password: "",
        confirm: ""
      });

    } catch (err) {

      setError(err.message);

    } finally {

      setLoading(false);

    }

  };

  return (
    <div className="su-layout">
      {/* Left Branding Panel */}
      <aside className="su-brand-panel">
        <div className="su-brand-top">
          <div className="su-logo">
            <ConvertIcon />
            <span className="su-logo-text">ConvertPro</span>
          </div>
        </div>

        <div className="su-brand-content">
          <h1 className="su-brand-title">Start converting files in seconds</h1>
          <p className="su-brand-sub">
            Join thousands of professionals who trust ConvertPro for fast, secure, and reliable file conversions.
          </p>

          <div className="su-features">
            {FEATURES.map((f) => (
              <div key={f.title} className="su-feature">
                <div className="su-feature-icon">{f.icon}</div>
                <div>
                  <span className="su-feature-title">{f.title}</span>
                  <span className="su-feature-desc">{f.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="su-brand-footer">© 2026 ConvertPro. All rights reserved.</p>
      </aside>

      {/* Right Form Panel */}
      <main className="su-form-panel">
        <div className="su-form-container">
            <Link to="/" className="su-back-home">
              <span aria-hidden="true">←</span>
              Back to Home
            </Link>
          <div className="su-form-header">
            <h2 className="su-form-title">Create your account</h2>
            <p className="su-form-sub">Get started with your free account</p>
          </div>

          <form className="su-form" onSubmit={handleSignup}>
            {/* Full Name */}
            <div className="su-field">
              <label className="su-label">Full Name</label>
              <input
                className="su-input"
                type="text"
                placeholder="Alex Sterling"
                value={form.name}
                onChange={update("name")}
              />
            </div>

            {/* Email */}
            <div className="su-field">
              <label className="su-label">Email Address</label>
              <input
                className="su-input"
                type="email"
                placeholder="alex@example.com"
                value={form.email}
                onChange={update("email")}
              />
            </div>

            {/* Password */}
            <div className="su-field">
              <label className="su-label">Password</label>
              <div className="su-input-wrap">
                <input
                  className="su-input su-input--icon"
                  type={showPwd ? "text" : "password"}
                  placeholder="Create a strong password"
                  value={form.password}
                  onChange={update("password")}
                />
                <button type="button" className="su-eye-btn" onClick={() => setShowPwd(!showPwd)}>
                  {showPwd ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div className="su-field">
              <label className="su-label">Confirm Password</label>
              <div className="su-input-wrap">
                <input
                  className="su-input su-input--icon"
                  type={showConfirm ? "text" : "password"}
                  placeholder="Confirm your password"
                  value={form.confirm}
                  onChange={update("confirm")}
                />
                <button type="button" className="su-eye-btn" onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>

            {/* Terms Checkbox */}
            <label className="su-checkbox-wrap">
              <button
                type="button"
                className={`su-checkbox ${agreed ? "su-checkbox--checked" : ""}`}
                onClick={() => setAgreed(!agreed)}
              >
                {agreed && <CheckIcon />}
              </button>
              <span className="su-checkbox-label">
                I agree to the <a href="#terms">Terms of Service</a> and <a href="#privacy">Privacy Policy</a>
              </span>
            </label>

            {error && (
              <p
                style={{
                  color: "#ef4444",
                  marginBottom: "12px"
                }}
              >
                {error}
              </p>
            )}

            {success && (
              <p
                style={{
                  color: "#22c55e",
                  marginBottom: "12px"
                }}
              >
                {success}
              </p>
            )}

            {/* CTA */}
            <button
              type="submit"
              className="su-btn-primary"
              disabled={
                !agreed || loading
              }
            >
              {loading
                ? "Creating Account..."
                : "Create Account"}
            </button>

            {/* Divider */}
            <div className="su-divider">
              <span className="su-divider-line" />
              <span className="su-divider-text">or continue with</span>
              <span className="su-divider-line" />
            </div>

            {/* OAuth */}
            {/* OAuth */}
            <div className="su-oauth-row">
              <button type="button" className="su-oauth-btn">
                <GoogleIcon /> Google
              </button>
              <button type="button" className="su-oauth-btn">
                <YahooIcon /> Yahoo
              </button>
              <button type="button" className="su-oauth-btn">
                <FacebookIcon /> Facebook
              </button>
              <button type="button" className="su-oauth-btn">
                <OutlookIcon /> Outlook
              </button>
              <button type="button" className="su-oauth-btn">
                <AppleIcon /> Apple
              </button>
            </div>
          </form>

          <p className="su-signin-link">
            Already have an account? <Link to="/login">
                                       Sign in
                                     </Link>
          </p>
        </div>
      </main>
    </div>
  );
}
